const safetyItems = [
  { area: 'Website Prüfung', recommendation: 'Nur offizielle Quellen nutzen' },
  { area: 'Datenschutz', recommendation: 'Keine privaten Daten teilen' },
  { area: 'Zahlung', recommendation: 'Sichere Zahlungsmethoden verwenden' },
  { area: 'Accounts', recommendation: 'Starkes Passwort verwenden' },
];

export default function SafetySection() {
  return (
    <section id="safety" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            Ist <strong>OOPBUY</strong> sicher?
          </h2>
          <div className="w-12 h-0.5 bg-primary-400 mx-auto mb-6"></div>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Sicherheit steht an erster Stelle. Hier sind unsere Empfehlungen für die sichere Nutzung des OOPBUY Spreadsheets.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/60">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="px-5 py-3.5 text-left font-semibold text-foreground-800 whitespace-nowrap">
                  Sicherheitsbereich
                </th>
                <th className="px-5 py-3.5 text-left font-semibold text-foreground-800 whitespace-nowrap">
                  Empfehlung
                </th>
              </tr>
            </thead>
            <tbody>
              {safetyItems.map((item, idx) => (
                <tr
                  key={item.area}
                  className={`border-t border-background-200/40 ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                  }`}
                >
                  <td className="px-5 py-3.5 font-medium text-foreground-900 whitespace-nowrap">
                    {item.area}
                  </td>
                  <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">
                    {item.recommendation}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}